export default __webpack_public_path__ + "static/media/ecommerce.fecda3b8.png";